import { basename } from "../utils/Url";
import { ApiList, ApiObject } from "../utils/Api";
import { defaultApiBuilder, defaultApiWithCustomUrlBuilder } from "../utils/axios/apiBuilder";
import { parseJSON } from "../utils/date";
import { getOrderQueryDirection } from "../utils/ordering";

const apiArea = defaultApiBuilder(parseJSON);
const apiAreaObject = defaultApiBuilder(ApiObject);
const apiAreaList = defaultApiBuilder(ApiList);

export const AxiosAreasAPI = {
  createArea: async data => {
    const response = await apiArea.post("/areas/create_complete/", data);
    return response.data;
  },
  editArea: async data => {
    const response = await apiArea.patch(
      `/areas/${data.id}/edit_area_and_record/`,
      data
    );
    return response.data;
  },
  editParentArea: async data => {
    const response = await apiArea.patch(
      `/areas/${data.id}/edit_parent/`,
      data
    );
    return response.data;
  },
  getAll: async (
    { active = true, search = "", expand = [], page = 1 },
    { signal }
  ) => {
    const params = {
      expand: ['_extra', '_links.record_set', ...expand].join(','),
      active,
      page
    };
    if (search) params.search = search;

    const response = await apiAreaList.get(`/areas/`, { params, signal });
    return response.data
  },
  getById: async ({ area_id }, { signal }) => {
    const params = {
      expand: ['_extra', '_links.record_set'].join(',')
    };

    const response = await apiAreaObject.get(`/areas/${area_id}/`, { params, signal });
    return response.data;
  },
  getRecords: async (area_id, ordering = null, page = 1) => {
    const params = {
      area: area_id,
      page
    };
    if (ordering) params.ordering = getOrderQueryDirection(ordering);

    const response = await apiArea.get(`/area_records/`, { params });
    return response.data;
  }
};
